import React, { useState, useEffect, useMemo } from 'react';
import ProjectPropOne from './itemProp/ProjectPropOne';
import SectionTitle from '../../elements/section-title/SectionTitle';
import { useTranslation } from 'react-i18next';

const ProjectOne = ({ parentClass, colSize, itemShow, columnGap }) => {
  const { t } = useTranslation();

  const filters = [
    { id: 1, label: t('Electricité') },
    { id: 2, label: t('Energie renouvelable') },
    { id: 3, label: t('Informatique') },
  ];

  // Wrap categoryData in useMemo to avoid unnecessary re-renders
  const categoryData = useMemo(() => ({
    1: [
      { id: 1, title: t('courantfort'), image: "/images/services/Eletricite/courant_fort.webp", link:"/service-Courant_Fort" },
      { id: 2, title: t('courantfaible'), image: "/images/services/Eletricite/courant_faible.webp", link:"/service-Courant_Faible"  },
      { id: 3, title: t('Audiovisuel'), image: "/images/services/Eletricite/audiovisuel.webp", link:"/service-Audiovisuel"  },
      { id: 4, title: t('Securite'), image: "/images/services/Eletricite/securite.webp" , link:"/service-Securite" },
    ],
    2: [
      { id: 5, title: t('Production d\'énergie'), image: "/images/services/EnergieRenouvelable/production_de_energie.webp", link:"/service-Productiondenergie"  },
      { id: 6, title: t('Stockage d\'énergie'), image: "/images/services/EnergieRenouvelable/stockage_électricité.webp", link:"/service-Stockagedenergie"  },
      { id: 7, title: t('Gestion d\'énergie'), image: "/images/services/EnergieRenouvelable/gestion-energie.webp" , link:"/service-Gestiondenergie" },
      { id: 8, title: t('Maintenance'), image: "/images/services/EnergieRenouvelable/maintenance.webp", link:"/service-Maintenance"  },
    ],
    3: [ //estes ja estao todos otimizados com o tamanho certo
      { id: 9, title: t('Developpement'), image: "/images/services/Informatique/Developpement.webp" , link:"/service-Developpement" },
      { id: 10, title: t('Web'), image: "/images/services/Informatique/Web.webp" , link:"/service-Web" },
      { id: 11, title: t('Integration'), image: "/images/services/Informatique/integration.webp", link:"/service-Integration"  },
      { id: 12, title: t('Strategie Sociale'), image: "/images/services/Informatique/Social_Media_Strategy.webp" , link:"/service-StrategieSociale" },
    ],
  }), [t]);

  const [activeFilter, setActiveFilter] = useState(1);
  const [visibleItems, setVisibleItems] = useState([]);

  useEffect(() => {
    if (categoryData[activeFilter]) {
      setVisibleItems(categoryData[activeFilter].slice(0, itemShow || 4));
    }
  }, [itemShow, activeFilter, categoryData]);

  const handleChange = (id) => {
    setActiveFilter(id);

    if (categoryData[id]) {
      setVisibleItems(categoryData[id].slice(0, itemShow || 4));
    }
  };

	return (
		<>
			<div className={`section section-padding-2 ${parentClass ? parentClass : ""}`} id="nossosprojetos">
				<div className="container">
					<SectionTitle
            // subtitle="Os nossos projetos"
						title={t('Une gamme de nos services les plus distingués')}
						textAlignment="heading-left mb--40"
						textColor=""
					/>
					<div className="isotope-button isotope-project-btn">
						{filters.map((filter) => (
							<button
								onClick={() => handleChange(filter.id)}
								className={filter.id === activeFilter ? "is-checked" : ""}
								key={filter.id}
							>
								{filter.label}
							</button>
						))}
					</div>
					<div className={`row ${columnGap ? columnGap : "row-35"}`}>
						{visibleItems.map((data) => (
							<div className={colSize ? colSize : "col-md-6"} key={data.id}>
								<ProjectPropOne portfolio={data} />
							</div>
						))}
					</div>
				</div>
				<ul className="shape-group-7 list-unstyled">
					<li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-2.webp"} alt="circle" /></li>
					<li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-2.webp"} alt="Line" /></li>
					<li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.webp"} alt="Line" /></li>
				</ul>
			</div>
		</>
	);
}

export default ProjectOne;
